const workorder = {
  WORKORDER: 'WORKORDER',
  WORKORDERS: 'WORKORDERS',
  WORKORDERS_COMPLETED: 'WORKORDERS_COMPLETED',
  WORKORDERS_DRAFT: 'WORKORDERS_DRAFT'
}

export { workorder }
